<template>
  <div class="rich-text-cell-wrapper">
    <span
      :id="cellId"
      class="rich-text-cell"
      @click="openEditor"
    >
      {{ plainTextPreview }}
    </span>
    <b-modal
      v-if="modalVisible"
      v-model="modalVisible"
      :title="fieldLabel || 'Edit Rich Text'"
      size="xl"
      no-close-on-backdrop
    >
      <template #title>
        {{ fieldLabel || 'Edit Rich Text' }}
        <modal-help topic="edit-rich-text-cell" />
      </template>
      <RichTextEditor
        v-model="editValue"
        :editable="true"
      />
      <template #footer>
        <button type="button" class="btn btn-secondary" @click="cancel">Cancel</button>
        <button type="button" class="btn btn-primary" @click="save">Save</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import RichTextEditor from './RichTextEditor.vue'

export default {
  name: 'RichTextCell',
  components: { RichTextEditor },
  props: {
    value: {
      type: [String, Object],
      default: ''
    },
    item: {
      type: Object,
      required: true
    },
    fieldKey: {
      type: String,
      required: true
    },
    fieldLabel: {
      type: String,
      default: ''
    },
    spreadsheetUniqueTitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      modalVisible: false,
      editValue: ''
    }
  },
  computed: {
    cellId () {
      const id = (this.item && this.item.id) != null ? this.item.id : Math.random().toString(36).slice(2)
      return `rtcell-${id}-${this.fieldKey}`
    },
    plainTextPreview () {
      const v = this.value
      if (v == null || v === '') return '—'
      if (typeof v !== 'string') return '—'
      // Replace images with placeholder before stripping HTML
      let preview = v.replace(/<img[^>]*alt="([^"]*)"[^>]*>/gi, ' [$1] ')
      preview = preview.replace(/<img[^>]*>/gi, ' [image] ')
      // Keep link text (file links show as "filename (size)")
      preview = preview.replace(/<a[^>]*>(.*?)<\/a>/gi, ' $1 ')
      // Strip remaining HTML tags
      preview = preview.replace(/<[^>]*>/g, '').trim()
      // Collapse multiple spaces
      preview = preview.replace(/\s+/g, ' ')
      if (!preview) return '—'
      return preview.length > 50 ? preview.substring(0, 50) + '...' : preview
    }
  },
  mounted () {
    this.$nextTick(() => this.openEditor())
  },
  methods: {
    openEditor () {
      this.editValue = (this.value && typeof this.value === 'string') ? this.value : ''
      this.modalVisible = true
    },
    save () {
      this.$emit('save', {
        item: this.item,
        fieldKey: this.fieldKey,
        newValue: this.editValue
      })
      this.modalVisible = false
    },
    cancel () {
      this.modalVisible = false
    }
  }
}
</script>

<style scoped>
.rich-text-cell-wrapper {
  width: 100%;
}
.rich-text-cell {
  cursor: pointer;
  padding: 4px 8px;
  display: block;
  width: 100%;
  border-radius: 3px;
  min-height: 1.4em;
  transition: background-color 0.1s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  color: #b0b0ae;
  font-style: italic;
  font-size: 0.9em;
}
.rich-text-cell:hover {
  background-color: rgba(154, 209, 43, 0.1);
  outline: 1px solid rgba(154, 209, 43, 0.3);
}
</style>
